import { AfterViewInit, Component, Input, inject } from '@angular/core';
import { User } from '@auth0/auth0-spa-js';
import { ImageService } from 'src/app/shared/services/image.service';
import { UserService } from 'src/app/shared/services/user.service';

import { MatMenuTrigger, MatMenu, MatMenuItem } from '@angular/material/menu';
import { MatCard, MatCardContent } from '@angular/material/card';
import { MatDivider } from '@angular/material/list';

@Component({
    selector: 'app-user-menu',
    templateUrl: './user-menu.component.html',
    styleUrls: ['./user-menu.component.scss'],
    imports: [MatMenuTrigger, MatMenu, MatMenuItem, MatCard, MatCardContent, MatDivider]
})
export class UserMenuComponent implements AfterViewInit {
  userSvc = inject(UserService);
  imgSvc = inject(ImageService);


  @Input() user: User | null | undefined;

  constructor() {
    this.user = this.userSvc.user;
  }

  ngAfterViewInit(): void {
    this.userSvc.userDataChanged.subscribe((usr) => {
      if (usr) {
        this.user = usr;
      }
    });
  }
  
  shouldShowMenu() {
    return this.user;
  }

  logout() {
    this.userSvc.logout();
  }
}
